import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';
import { FILE_URL } from './Constants';
import { useSearchParams } from 'react-router-dom';
import TintucPageApi from './TintucPageApi';

const AdminTintucPage = ({ currentMenu, clickChangeMenu, changeCurrentPostId, openCategoryPage }) => {

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(1);
    const [isLoading, setIsLoading] = useState(false); // Manage loading state
    const [showConfirm, setShowConfirm] = useState(false);
    const [deletePostId, setDeletePostId] = useState(null);
    const [currentM, setCurrentM] = useState(currentMenu); // current menu
    const [danhmuc, setDanhmuc] = useState([]);
    const [catId, setCatId] = useState(null);
    const [titleSearch, setTitleSearch] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');

    const callApi = (currentMenu, currentPage, catId, titleSearch) => {
        // check menu to call api
        switch (currentMenu) {
            case 'trang':
                AdminApi.getListTinTucAdmin(currentPage, 10, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data);
                })
                TintucPageApi.getAllType(10).then((data) => {
                    setDanhmuc(data);
                }).catch((error) => {
                    console.error("Failed to fetch data:", error);
                });
                break;
            case 'tintuc':
                AdminApi.getListTinTucAdmin(currentPage, 16, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data); // Update state with the resolved data
                })
                TintucPageApi.getAllType(16).then((data) => {
                    setDanhmuc(data); // Update state with the resolved data
                }).catch((error) => {
                    console.error("Failed to fetch data:", error); // Handle errors
                });
                break;
            case 'video':
                AdminApi.getListTinTucAdmin(currentPage, 17, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data); // Update state with the resolved data
                })
                TintucPageApi.getAllType(17).then((data) => {
                    setDanhmuc(data); // Update state with the resolved data
                }).catch((error) => {
                    console.error("Failed to fetch data:", error); // Handle errors
                });
                break;
            case 'audio':
                AdminApi.getListTinTucAdmin(currentPage, 18, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data); // Update state with the resolved data
                })
                TintucPageApi.getAllType(18).then((data) => {
                    setDanhmuc(data); // Update state with the resolved data
                }).catch((error) => {
                    console.error("Failed to fetch data:", error); // Handle errors
                });
                break;
            case 'kinhsach':
                AdminApi.getListTinTucAdmin(currentPage, 19, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data); // Update state with the resolved data
                })
                TintucPageApi.getAllType(19).then((data) => {
                    setDanhmuc(data); // Update state with the resolved data
                }).catch((error) => {
                    console.error("Failed to fetch data:", error); // Handle errors
                });
                break;
            case 'thongbao':
                AdminApi.getListTinTucAdmin(currentPage, 22, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data); // Update state with the resolved data
                })
                TintucPageApi.getAllType(22).then((data) => {
                    setDanhmuc(data); // Update state with the resolved data
                }).catch((error) => {
                    console.error("Failed to fetch data:", error); // Handle errors
                });
                break;
            case 'hinhanh':
                AdminApi.getListTinTucAdmin(currentPage, 23, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data); // Update state with the resolved data
                })
                TintucPageApi.getAllType(23).then((data) => {
                    setDanhmuc(data); // Update state with the resolved data
                }).catch((error) => {
                    console.error("Failed to fetch data:", error); // Handle errors
                });
                break;
            case 'giangsu':
                AdminApi.getListTinTucAdmin(currentPage, 26, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data);
                })
                TintucPageApi.getAllType(26).then((data) => {
                    setDanhmuc(data);
                }).catch((error) => {
                    console.error("Failed to fetch data:", error);
                });
                break;
            case 'guongsangtuhanh':
                AdminApi.getListTinTucAdmin(currentPage, 27, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data);
                })
                TintucPageApi.getAllType(27).then((data) => {
                    setDanhmuc(data);
                }).catch((error) => {
                    console.error("Failed to fetch data:", error);
                });
                break;
            case 'audiotheobo':
                AdminApi.getListTinTucAdmin(currentPage, 28, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data);
                })
                TintucPageApi.getAllType(28).then((data) => {
                    setDanhmuc(data);
                }).catch((error) => {
                    console.error("Failed to fetch data:", error);
                });
                break;
            case 'slideshowheader':
                AdminApi.getListTinTucAdmin(currentPage, 20, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data);
                })
                TintucPageApi.getAllType(20).then((data) => {
                    setDanhmuc(data);
                }).catch((error) => {
                    console.error("Failed to fetch data:", error);
                });
                break;
            case 'slideshowhome':
                AdminApi.getListTinTucAdmin(currentPage, 21, catId, titleSearch).then((data) => {
                    setTotalPages(data.totalPages);
                    setTotalRecords(data.totalRecords);
                    setData(data.data);
                })
                TintucPageApi.getAllType(21).then((data) => {
                    setDanhmuc(data);
                }).catch((error) => {
                    console.error("Failed to fetch data:", error);
                });
                break;
            default:
                break;
        }
    }

    const formatDate = (isoDateString) => {
        const date = new Date(isoDateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ampm = hours >= 12 ? 'CH' : 'SA';
        hours = hours % 12 || 12; // Convert 0 to 12
        hours = String(hours).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    };

    const handlePageClick = (page) => {
        setCurrentPage(page);
    };


    const handleClickDeletePost = (postId) => {
        setShowConfirm(!showConfirm);
        setDeletePostId(postId);
    }

    const handleDeletePost = async () => {
        try {
            setIsLoading(true);
            switch (currentMenu) {
                case 'tintuc':
                    await AdminApi.deletePost(deletePostId);
                    break;
                case 'video':
                    await AdminApi.deleteVideoPost(deletePostId);
                    break;
                case 'audio':
                    await AdminApi.deleteAudioPost(deletePostId);
                    break;
                case 'kinhsach':
                    await AdminApi.deleteKinhSachPost(deletePostId);
                    break;
                case 'thongbao':
                    await AdminApi.deleteThongBaoPost(deletePostId);
                    break;
                case 'hinhanh':
                    await AdminApi.deleteHinhAnhPost(deletePostId);
                    break;
                case 'giangsu':
                    await AdminApi.deleteGiangSuPost(deletePostId);
                    break;
                case 'trang':
                    await AdminApi.deleteTrangPost(deletePostId);
                    break;
                case 'guongsangtuhanh':
                    await AdminApi.deleteGuongSangTuHanhPost(deletePostId);
                    break;
                case 'audiotheobo':
                    await AdminApi.deleteAudioTheoBoPost(deletePostId);
                    break;
                case 'slideshowheader':
                    await AdminApi.deleteSlideShowHeaderPost(deletePostId);
                    break;
                case 'slideshowhome':
                    await AdminApi.deleteSlideShowHomePost(deletePostId);
                    break;
                default:
                    break;
            }
            callApi(currentMenu, currentPage);
        } catch (error) {
            console.error("Error deleting post:", error);
        } finally {
            setIsLoading(false);
            setShowConfirm(false); // Close modal
        }
    };

    const handleEditPost = async (postId) => {
        clickChangeMenu('edit')
        changeCurrentPostId(postId);
    };

    const clickChangeCat = (temp) => {
        setCatId(temp.target.value);
        setSelectedCategory(temp.target.value);
        setCurrentPage(1);

        callApi(currentMenu, 1, temp.target.value, titleSearch);
    }

    const handleInputChange = (event) => {
        setTitleSearch(event.target.value);
        setCurrentPage(1);
        callApi(currentMenu, 1, catId, event.target.value);
    };

    useEffect(() => {
        callApi(currentMenu, currentPage, catId, titleSearch);
    }, [currentPage]);

    useEffect(() => {
        setCurrentPage(1);
        setSelectedCategory("");
        setTitleSearch("");
        setCatId([]);

        callApi(currentMenu, 1, [], "");
    }, [currentMenu]);

    const menuTitles = {
        tintuc: 'Tin tức', trang: 'Trang', video: 'Video', audio: 'Audio',
        kinhsach: 'Kinh sách', thongbao: 'Thông báo', hinhanh: 'Hình ảnh',
        giangsu: 'Giảng sư',
        guongsangtuhanh: 'Gương sáng tu hành', audiotheobo: 'Audio theo bộ',
        slideshowheader: 'Slideshow Header', slideshowhome: 'Slideshow Home'
    };
    const menuTypes = {
        trang: 10, tintuc: 16, video: 17, audio: 18, kinhsach: 19,
        slideshowheader: 20, slideshowhome: 21, thongbao: 22, hinhanh: 23,
        giangsu: 26, guongsangtuhanh: 27, audiotheobo: 28
    };
    const pageTitle = menuTitles[currentMenu] || currentMenu;

    const getColumns = (menu) => {
        switch (menu) {
            case 'trang': return ['stt', 'title', 'sort', 'date_create', 'date_edit', 'active', 'actions'];
            case 'tintuc': return ['stt', 'title', 'categories', 'thumb', 'date_create', 'date_edit', 'active', 'is_new', 'actions'];
            case 'video':
            case 'audio': return ['stt', 'title', 'categories', 'thumb', 'author', 'date_create', 'date_edit', 'active', 'is_new', 'actions'];
            case 'kinhsach':
            case 'hinhanh': return ['stt', 'title', 'categories', 'thumb', 'sort', 'author', 'date_create', 'date_edit', 'active', 'is_new', 'actions'];
            case 'thongbao': return ['stt', 'title', 'author', 'date_create', 'date_edit', 'active', 'actions'];
            case 'giangsu': return ['stt', 'title', 'thumb', 'sort', 'author', 'date_create', 'active', 'actions'];
            case 'guongsangtuhanh': return ['stt', 'title', 'thumb', 'sort', 'author', 'active', 'actions'];
            case 'audiotheobo': return ['stt', 'title', 'thumb', 'author', 'active', 'actions'];
            case 'slideshowheader': return ['stt', 'thumb', 'sort', 'author', 'date_create', 'date_edit', 'active', 'actions'];
            case 'slideshowhome': return ['stt', 'thumb', 'sort', 'author', 'date_create', 'date_edit', 'actions'];
            default: return ['stt', 'thumb', 'title', 'categories', 'active', 'actions'];
        }
    };

    const columnDefinitions = {
        stt: { label: 'STT', width: '40px', align: 'center', render: (item, index) => (currentPage - 1) * 16 + index + 1 },
        thumb: {
            label: 'Hình ảnh', width: '80px', render: (item) => (
                item.thumb ? (
                    <img
                        src={FILE_URL + item.thumb}
                        alt=""
                        style={{ width: '60px', height: '45px', objectFit: 'cover', borderRadius: '3px' }}
                    />
                ) : <span style={{ color: '#999', fontSize: '11px' }}>Chưa có</span>
            )
        },
        title: { label: 'Tiêu đề', render: (item) => item.title },
        categories: { label: 'Chuyên mục', render: (item) => item.categories },
        sort: { label: 'Thứ tự', width: '60px', align: 'center', render: (item) => item.sort },
        author: { label: 'Tác giả', render: (item) => item.author || item.user_create },
        date_create: { label: 'Ngày tạo', width: '150px', render: (item) => item.date_create ? formatDate(item.date_create) : '' },
        date_edit: { label: 'Chỉnh sửa lần cuối', width: '150px', render: (item) => item.date_edit ? formatDate(item.date_edit) : '' },
        active: { label: 'Kích hoạt', width: '60px', align: 'center', render: (item) => <input type="checkbox" checked={item.active} readOnly /> },
        is_new: { label: 'New', width: '40px', align: 'center', render: (item) => <input type="checkbox" checked={item.is_new} readOnly /> },
        actions: {
            label: 'Thao tác', width: '140px', render: (item) => (
                <div style={{ display: 'flex', gap: '5px' }}>
                    <a
                        onClick={() => handleEditPost(item.id)}
                        className="btn btn-success btn-small"
                        title="Sửa">
                        <i className="coloredicon page-white-edit" /> <strong>Sửa</strong>
                    </a>
                    <a
                        onClick={() => handleClickDeletePost(item.id)}
                        disabled={isLoading}
                        className="btn btn-danger btn-small delete-link"
                        title="Xóa">
                        <i className="coloredicon delete" /> <strong>Xóa</strong>
                    </a>
                </div>
            )
        }
    };

    const columns = getColumns(currentMenu);

    return (
        <div>

            <div className="social-box">
                <h3 className="page-title">{pageTitle}</h3>
                <div className="header">
                    <div className="btn-group">
                        <a className="btn btn-primary"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                clickChangeMenu("create");
                            }}>
                            <i className="icon-pencil" /> Tạo
                        </a>
                        {!['trang', 'thongbao', 'giangsu', 'guongsangtuhanh', 'audiotheobo', 'slideshowheader', 'slideshowhome'].includes(currentMenu) && (
                            <a className="btn" style={{ marginLeft: '5px' }}
                                href="#" onClick={e => {
                                    e.preventDefault();
                                    if (openCategoryPage) openCategoryPage(menuTypes[currentMenu], pageTitle);
                                }}>
                                <i className="icon-folder-open" /> Chuyên mục
                            </a>
                        )}
                    </div>
                </div>
                <div className="body">
                    <div>
                        <form method="get" action="/Admin/Content" style={{ display: 'inline-block', width: '50%' }} noValidate="novalidate">
                            <input type="text"
                                id="searchkeywords"
                                name="searchkeywords"
                                placeholder={`Nhập tên ${pageTitle}`}
                                className="form-control"
                                style={{
                                    display: 'inline-block',
                                    minWidth: '95%',
                                    height: '30px'
                                }}
                                value={titleSearch}
                                onChange={handleInputChange} />
                        </form>
                        {!['trang', 'thongbao', 'giangsu', 'guongsangtuhanh', 'audiotheobo', 'slideshowheader', 'slideshowhome'].includes(currentMenu) && (
                            <select
                                id="category"
                                style={{
                                    display: 'inline-block',
                                    minWidth: '20%',
                                    marginLeft: '20px',
                                    height: '30px'
                                }}
                                value={selectedCategory}
                                onChange={e => {
                                    e.preventDefault();
                                    clickChangeCat(e);
                                }}
                            >
                                <option value="">-- Tất cả --</option>
                                {danhmuc?.map((item, index) => (
                                    <option key={index} value={item.Id}>{item.Name}</option>
                                ))}
                            </select>
                        )}
                    </div>
                </div>
            </div>

            <div className="table-container">
                <table cellPadding={0} cellSpacing={0} border={0} className="table table-hover">
                    <thead>
                        <tr>
                            {columns.map(col => (
                                <th key={col} width={columnDefinitions[col].width}>{columnDefinitions[col].label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                {columns.map(col => (
                                    <td key={col} style={{ verticalAlign: 'middle', textAlign: columnDefinitions[col].align || 'left' }}>
                                        {columnDefinitions[col].render(item, index)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
                {isLoading && (
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <p>Deleting, please wait...</p>
                    </div>
                )}
                {showConfirm && (
                    <div className="modal-overlay1">
                        <div className="modal1">
                            <p>Bạn có chắc chắn muốn xóa bài viết này không?</p>
                            <div className="modal-actions1">
                                <button
                                    onClick={() => handleDeletePost()}
                                    disabled={isLoading}
                                    className="btn btn-danger"
                                >
                                    {isLoading ? "Đang xóa..." : "Xóa"}
                                </button>
                                <button
                                    onClick={() => handleClickDeletePost(null)}
                                    className="btn btn-secondary"
                                >
                                    Hủy
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div>
                <div style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    Số lượng bản ghi: {totalRecords}
                </div>
                <div style={{ color: 'red' }}>
                    Đang xem trang {currentPage} (trong {totalPages} trang)
                </div>
                <div className="row" style={{ float: 'left', marginLeft: '5px' }}>
                    <div className="col-md-12 col-sm-12 col-xs-12"
                        style={{ paddingLeft: '0px' }}>
                        <div className="pagination-container">
                            <ul className="pagination">
                                {currentPage > 1 && (
                                    <>
                                        <li className="PagedList-skipToFirst">
                                            <a onClick={() => handlePageClick(1)}>««</a>
                                        </li>
                                        <li className="PagedList-skipToPrevious">
                                            <a onClick={() => handlePageClick(currentPage - 1)}>«</a>
                                        </li>
                                    </>
                                )}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .slice(Math.max(0, currentPage - 5), Math.min(totalPages, currentPage + 4))
                                    .map((page) => (
                                        <li key={page} className={currentPage === page ? 'active' : ''}>
                                            <a onClick={() => handlePageClick(page)}>{page}</a>
                                        </li>
                                    ))}
                                {currentPage < totalPages && (
                                    <>
                                        <li className="PagedList-skipToNext">
                                            <a onClick={() => handlePageClick(currentPage + 1)}>»</a>
                                        </li>
                                        <li className="PagedList-skipToLast">
                                            <a onClick={() => handlePageClick(totalPages)}>»»</a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminTintucPage;
